<ion-content class="employee-transfer">
    <ng-container>
        <app-header [isParentPage]="false" [title]="'Employee Transfers'"></app-header>
        <ion-grid class="container-grid">
            <ion-row class="filter-row">
                <ion-grid>
                    <ion-row>
                        <ion-col>
                            <ion-input [readonly]="authService.user.isCustomerUser" [disabled]="authService.user.isCustomerUser" type="text" [(ngModel)]="customer" placeholder="Enter customer number" class="ion-text-left color-light"  (keydown.enter)="onEnterKey($event)"></ion-input>
                        </ion-col>
                        <ion-col>
                            <ion-input type="text" [(ngModel)]="deptNo" placeholder="Enter department number" class="ion-text-left color-light"  (keydown.enter)="onEnterKey($event)"></ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-input placeholder="From"  (keydown.enter)="$event.preventDefault()" type="date" [(ngModel)]="startDate" class="ion-text-left color-light"></ion-input>
                        </ion-col>
                        <ion-col>
                            <ion-input placeholder="To"   (keydown.enter)="$event.preventDefault()" type="date" [(ngModel)]="endDate" class="ion-text-left color-light"></ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-select interface="popover" placeholder="Select Into or Out of Department" value="1" (ionChange)="selectDepartmentStatus($event)">
                                <ion-select-option value="1">Into Department</ion-select-option>
                                <ion-select-option value="2">Out of Department</ion-select-option>
                            </ion-select>
                        </ion-col>
                        <ion-col>
                            <ion-button (click)="getTransfers()" color="gallaghergreen" class="btn-box-shadow"><span>Show</span></ion-button>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-row>
            <div class="page-loader" style="padding-top:10%" *ngIf="!loaded">
                <ion-spinner></ion-spinner>
            </div>
            <ion-row *ngIf="(totalPages <= 0) && searchProcessed">
                <ion-col>
                    <div class="no-results">
                        <span>No Results Found</span>
                    </div>
                </ion-col>
            </ion-row>
            <ion-row class="table-row" *ngIf="totalPages > 0">
                <div class="ion-padding table-container">
                    <app-employee-transfer-table [mode]="'gl'" (paging)="setPage($event)" [pageSize]="pageSize" [pageNumber]="currentPage" [rows]="rows"  [totalElements]="totalElements" ></app-employee-transfer-table>
                </div>
            </ion-row>
        </ion-grid>
         <ion-grid>
           
        </ion-grid>
    </ng-container>
</ion-content>